import React, { useState } from 'react';

const CopyCommand = ({ text, buttonText = "Copy" }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <code style={{
        backgroundColor: '#f1f1f1',
        padding: '4px 8px',
        borderRadius: '4px',
        fontSize: '12px',
        fontFamily: 'monospace'
      }}>
        {text}
      </code>
      <button
        onClick={handleCopy}
        style={{
          padding: '4px 8px',
          fontSize: '12px',
          backgroundColor: copied ? '#28a745' : '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        {copied ? 'Copied!' : buttonText}
      </button>
    </div>
  );
};

export default CopyCommand;
